import { configureStore } from '@reduxjs/toolkit';
import authReducer from '../features/auth/authSlice';
import cropReducer from '../features/crops/cropSlice';
import cropVarietiesReducer from '../features/cropVarieties/cropVarietiesSlice';
import equipmentReducer from '../features/equipment/equipmentSlice';
import resourceReducer from '../features/resources/resourceSlice';
import salesReducer from '../features/sales/salesSlice';
import taskReducer from '../features/tasks/taskSlice';
import vendorReducer from '../features/vendors/vendorSlice';
import weatherReducer from '../features/weather/weatherSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    crops: cropReducer,
    cropVarieties: cropVarietiesReducer,
    equipment: equipmentReducer,
    resources: resourceReducer,
    sales: salesReducer,
    tasks: taskReducer,
    vendors: vendorReducer,
    weather: weatherReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        // Ignore these action types
        ignoredActions: ['auth/loginUser/fulfilled', 'auth/signupUser/fulfilled'],
        // Ignore these field paths in all actions
        ignoredActionPaths: ['payload.user', 'meta.arg'],
        // Ignore these paths in the state
        ignoredPaths: ['auth.user'],
      },
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;